import { createStore } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import user from './modules/user';

export default createStore({
  namespaced: true,
  state: {
  },
  modules: {
    user,
  },
  mutations: {
    // 重置vuex本地储存状态
    resetStore(state) {
      Object.keys(state).forEach((key) => {
        state[key] = cloneDeep(window.SITE_CONFIG.storeState[key]);
      });
    },
  },
});
